<template>
  <div>
    <!--    {{this.$store.state.endorsementInvite.chartObj}}-->
    <div v-if="Object.keys(this.$store.state.endorsementInvite.chartObj).length === 0">
    </div>
    <div v-else v-for="obj in this.$store.state.endorsementInvite.chartObj" :key="Object(obj).key" class="mb-base">
      <div class="w-full items-left">

        <h4>{{obj.pm}}</h4>
      </div>
      <!--      {{obj.series.length}}-->
      <!--      {{obj.chartOptions}}-->
      <!--      {{obj.series}}-->
      <vue-apex-charts
          v-if="obj.series.length >0"
          type="line"
          height="350"
          :options="obj.chartOptions"
          :series="obj.series"
      >
      </vue-apex-charts>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import i18n from "@/i18n/i18n";
//import ccd from "@/assets/data/charactersistic-competency-definition.js";

export default {
  name: 'EndorsementChart',
  props:["endorsementData"],
  components: {
    VueApexCharts
  },
  data() {
    return {
      userType: this.$store.state.AppActiveUser.userType,
      endorsement_invite_data: null,
      endorsementInvitePrgmsId:'',
      endorsement_invite_emails: [],
      feedback_sent_dates: [],
      inviteUserName:null,
      confirmcancelSingleEmail:false,
      confirmExpireSingleEmail:false,
      externalFeedbackId:null,
      endorsementChartObj: {},
      endorsementNewObj: {},
      progress_measures_list: [],
      custom_progress_measures: [],
      terminology:null,
      CCD: this.$t("addNewSkill.data"),
      themeColors: [
        "#FF7F00", "#FF0000", "#9400D3", "#0000FF", "#FFFF00",
        '#7367F0', '#28C76F', '#EA5455', '#FF9F43',
        '#1E1E1E','#4800FF','#606060','#7F0000',
        '#FF006E','#0094FF','#00FFFF','#007F46',
        '#7F6A00','#FF7F7F','#7F0037','#007F0E',
        '#7FC9FF','#B200FF','#FF6A30','#7FFFC5',
        '#FFE97F','#7F92FF','#D67FFF','#007F7F'
      ],
      goalCompletedPopup: false,
      scheduleInvite: false,
      confirmscheduleInvite:false,
      resetscheduleInvite:false,
      confirmResetscheduleInvite:false,
      markGoalCompletedConfirmation:false,
      email:'',
      endorsementInvitePrgms:null,
      edorsementId:'',
      compenTencyId:'',
      emailScheduleData:{},
      skillName:"",
      training_duration:"",
      cancelDisable:true,
      traineeName:"",
      markGoalCompletedEmail:false,

    }
  },
  watch: {},
  computed: {

  },
  mounted(){
    console.log("feedData",this.endorsementData)
    this.endorsementNewObj[0] = {
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          zoom: {
            enabled: false


          },

        },

        colors: this.themeColors,

        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 4,
          colors: ["#808080"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 12,
          }
        },
        stroke: {
          curve: "smooth"
        },
        title: {
          text: '', // this.progress_measures_list[pm]["pm"],
          align: "left"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {

          categories: [1,2,3,4,5,6],
          // title: {
          //   // text: "Time",
          //   style: {
          //     fontSize: "15px",
          //     fontFamily: "Montserrat, Helvetica, Arial, sans-serif"
          //   }
          // }
        },
        tooltip: {
          enabled: true,
        },
        scaleLabel: {
          display: false,
          labelString: 'x axis'
        },
        yaxis: {
          show: true,
          tickAmount: 2,
          min: -100,
          max: 100,
          labels: {
            formatter:
                function (value,opts) {
                  // let count=0;
                  // let a=[];
                  if(value ==100){
                    return   i18n.t('GapClosed');
                  }
                  else if(value >0 && value <100){
                    return   i18n.t('GapSmaller');
                  }
                  else if(value===0){
                    // count=count+1;
                    // console.log('count',count);
                    // a.push(count);
                    //
                    // console.log(a);
                    // if(count>=2){
                    //   return "Same Gap";
                    // }
                    // else{
                    return    i18n.t('Benchmark_1');
                    // }
                  }
                  else if(value<0){
                    return   i18n.t('GapBigger');
                  }
                  else {
                    return  i18n.t('NoRating');
                  }
                }
          },
          forceNiceScale: false,
          decimalsInFloat:false,
          title: {
            text: this.$t('Progress'),
            style: {
              fontSize: "15px",
              fontFamily: "Montserrat, Helvetica, Arial, sans-serif"
            }
          }
        }
      }
    };
    this.endorsementNewObj[0].series.push({
      pmId: this.endorsementData.pmId,
      pmMap: this.endorsementData.pmMap,
      name: this.inviteUserName,
    });
    //  if (this.progress_measures_list[pm].pmId === resData[x]["endorsementInvitePrgms"][y]["progressMeasureId"]) {
    // console.log("progress_measures_list",this.progress_measures_list)
    // this.endorsementNewObj[pm]["pm"] = this.progress_measures_list[pm].pm
    // this.endorsementNewObj[pm]["pmId"] = this.progress_measures_list[pm].pmId
    // console.log('data email',this.progress_measures_list[pm].pmMap);
    // this.endorsementNewObj[pm].series.push({
    //   pmId: this.progress_measures_list[pm].pmId,
    //   pm: this.progress_measures_list[pm].pm,
    //   pmMap: this.progress_measures_list[pm].pmMap,
    //   name: resData[x]["inviteUserName"],
    //   email: resData[x]["inviteeEmail"],
    //   endorsementInviteId:resData[x]["endorsementInvitePrgms"][y]["endorsementInviteId"]
    // });
    // const eF = [];
    //  const benchmarkGap= 10;
    //  var benchmarkGap = resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"]
    // if(1<benchmarkGap<=10){
    //    benchmarkGap = resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"];
    //   console.log('benchmarkGap',benchmarkGap);
    //
    // }
    // else{
    //    benchmarkGap = 1;
    // }
    //const benchmarkGap = 1;

    // const minGap = this.minGap(resData[x]["endorsementInvitePrgms"][y]["externalFeedback"]);
    // const maxGap = this.maxGap(resData[x]["endorsementInvitePrgms"][y]["externalFeedback"]);
    //console.log('sort data',resData)
    // console.log(   'sort data',resData.sort((a, b) => b.date - a.date))
    const eF = [];
    var i=1;
    for (const x in this.endorsementData.feedback) {
      console.log(this.endorsementData.feedback[x])   ;
      if(this.endorsementData.feedback[x]["currentGap"] !== null) {
        //    console.log(benchmarkGap);
        let      benchmarkGap=this.endorsementData.feedback[0]["currentGap"];
        if(this.endorsementData.feedback[0]["currentGap"]===0){

          benchmarkGap=-1;
        }
        else{
          benchmarkGap=this.endorsementData.feedback[0]["currentGap"];
        }
        if (this.endorsementData.feedback[x]["feedbackReceivedDate"] !== null) {
          console.log(benchmarkGap);
          eF.push({
            y:((benchmarkGap - this.endorsementData.feedback[x]["currentGap"]) * 100) / benchmarkGap,
            x: i++,
          });
        }
        else{
          eF.push({
            y:((benchmarkGap - this.endorsementData.feedback[x]["currentGap"]) * 100) / benchmarkGap,
            x: i++
          });
        }
      }
    }
    this.endorsementNewObj[0]["series"][this.endorsementNewObj[0]["series"].length - 1]["data"] = eF;
    console.log('eF Data',eF );
    console.log('eF Data', this.endorsementNewObj[0]["series"][this.endorsementNewObj[0]["series"].length - 1]["data"] );
    this.$store
        .dispatch("endorsementInvite/updateChartData", this.endorsementNewObj)
        .catch(err => {
          console.log(err);
        });
    //  console.log('Hello',resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"]);
    // if(resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"] !== null) {
    //   //    console.log(benchmarkGap);
    //   var      benchmarkGap=resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"];
    //   if(benchmarkGap!==null){
    //
    //     benchmarkGap=resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][0]["currentGap"];
    //   }
    //   else{
    //     benchmarkGap=10;
    //   }
    //   if (resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["feedbackReceivedDate"] !== null) {
    //     console.log(benchmarkGap);
    //     eF.push({
    //       y:((benchmarkGap - resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"]) * 100) / benchmarkGap,
    //       x: i++,
    //     });
    //   }
    //   else{
    //     eF.push({
    //       y:((benchmarkGap - resData[x]["endorsementInvitePrgms"][y]["externalFeedback"][z]["currentGap"]) * 100) / benchmarkGap,
    //       x: i++
    //     });
    //   }
    // }
    // }
    //   this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["minGap"] = 8;
    // this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["maxGap"] = 8;
    // console.log('eF Data',eF );
    // this.endorsementNewObj[pm]["series"][this.endorsementNewObj[pm]["series"].length - 1]["data"] = eF;

    // this.$store
    //   .dispatch("endorsementInvite/updateChartData", this.endorsementNewObj)
    //   .catch(err => {
    //     console.log(err);
    //   });
    // }
    //this.inviteeEmail=resData;
    //   }







  },
  methods: {

  },
  created () {
    console.log(this.$store.state.endorsementInvite.chartObj);
    this.inviteUserName=this.$route.query.inviteename;
  },

};
</script>

<style scoped>
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
.truncate-pm {
  width: 80%;
  white-space: normal !important;
  margin-left: 1.5rem;
}
.no-box-shadow {
  box-shadow: none !important;
}
.t-sd {
  white-space: normal !important;
}
.skill-icon {
  width: 25px;
  height: 25px;
}
.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 80%;
  margin-left:10%;margin-right:10%;
}

.left {
  border: 1px solid #ffffff;
  text-align: left;
  padding: 8px;
}
.right {
  border: 1px solid #ffffff;
  text-align: right;
  padding: 8px;
}
.con-vs-dialog .vs-dialog footer .vs-button:last-of-type {
  /* border-color: rgba(0, 0, 0, 0.2) !important; */
  display: none;
}
.vs-button-flat {
  display: none;
}
.con-vs-popup .vs-popup {
  -webkit-transition: all .2s;
  transition: all .2s;
  z-index: 100;
  width:400px ;
  margin: 10px;
  max-width: 400px;
  max-height: calc(100% - 30px);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
  box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
  background: #fff;
  -webkit-animation: rebound .3s;
  animation: rebound .3s;
}
tr:nth-child(even) {
  background-color: #ffffff;
}
</style>
